import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Dropdown, Menu } from 'semantic-ui-react';
import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

export default
@inject('classroomManager', 'studentCourseDrivenExperienceManager', 'topNavManager', 'userManager')
@observer
class ClassMenu extends Component {
  constructor(props) {
    super(props);
    this.DropdownObserver = SatCoreComponent('DropdownObserver');
  }

  render() {
    const { DropdownObserver } = this;

    const {
      classroomManager,
      handleChangeStudentClassroom,
      handleJoinClass,
      joinClassLabel,
      optionTitleLabel,
      studentCourseDrivenExperienceManager,
      t,
      topNavManager,
      userManager
    } = this.props;
    const { currentClassroomId } = classroomManager;
    const classLabel = currentClassroomId ? classroomManager.getClassName(currentClassroomId) : joinClassLabel;
    return (
      <Menu.Item
        as='a'
        className='tnav-tab class-menu'
        data-nav-item
        onClick={() => {
          // placeholder
        }}
        onMouseEnter={() => {
          topNavManager.setIsTopNavClassMenuOpen(true);
        }}
        onMouseLeave={() => {
          topNavManager.setIsTopNavClassMenuOpen(false);
        }}
        role='button'
        tabIndex='-1'>
        <div className='aria-offscreen' id='class-menu-instructions'>
          {topNavManager.isTopNavClassMenuOpen ? t('ariaClassMenuOpenInstructions') : t('ariaClassMenuClosedInstructions')}
        </div>
        <DropdownObserver>
          <Dropdown
            aria-describedby='class-menu-instructions'
            aria-expanded={topNavManager.isTopNavClassMenuOpen}
            aria-haspopup='listbox'
            aria-label={t('ariaClassMenuDropdownLabel', { classLabel })}
            as={(props) => <div {...props} role='listbox' />}
            className='class-selector'
            closeOnChange
            icon='caret down'
            open={topNavManager.isTopNavClassMenuOpen}
            options={[
              ...(!userManager.isSsoUser ? [{
                as: (props) => <div {...props} aria-label={joinClassLabel} role='option' tabIndex='-1' />,
                className: 'switch-option',
                key: 'classO_switch',
                onClick: handleJoinClass,
                text: (
                  <>
                    <span className='text'>{optionTitleLabel}</span>
                    <Button className='join-class'
                      onClick={handleJoinClass}
                      primary
                      tabIndex={topNavManager.isTopNavClassMenuOpen ? '0' : '-1'}
                      type='button'>
                      {joinClassLabel}
                    </Button>
                  </>
                )
              }] : []),
              ...classroomManager.classroomsArray.map(({ id }) => {
                const classroomId = id;
                const classroomName = classroomManager.getClassName(classroomId);
                return ({
                  as: (props) => (
                    <div {...props}
                      aria-label={classroomName} role='option' tabIndex={topNavManager.isTopNavClassMenuOpen ? '0' : '-1'} />
                  ),
                  key: `classO_${id}`,
                  onClick: async (_event, _data) => {
                    const { currentClassroomId } = classroomManager;

                    const {
                      allowStudentCourseDrivenExperience,
                      selectedCourseDrivenCarouselIndex
                    } = studentCourseDrivenExperienceManager;

                    if (allowStudentCourseDrivenExperience && classroomId !== currentClassroomId && selectedCourseDrivenCarouselIndex) {
                      studentCourseDrivenExperienceManager.setSelectedCourseDrivenCarouselIndex(0);
                      return handleChangeStudentClassroom(classroomId);
                    } else {
                      return handleChangeStudentClassroom(classroomId);
                    }
                  },
                  text: classroomName,
                  value: classroomId
                });
              })
            ]}
            selectOnBlur={false}
            simple
            tabIndex='0'
            trigger={<div className='class-dropdown-selection' tabIndex='-1'>{classLabel}</div>}
            value={currentClassroomId} />
        </DropdownObserver>
      </Menu.Item>
    );
  }
}

SatCoreRegister('ClassMenu', ClassMenu);
